import * as z from "zod/v4";

const AeoPromptSchema_ = z.object({
  id: z.bigint(),
  prompt: z.string(),
  category: z.string(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});

export const AeoPromptSchema: z.ZodType<AeoPrompt> = AeoPromptSchema_;
export interface AeoPrompt extends z.infer<typeof AeoPromptSchema_> {}

export const getAeoPrompts = {
  name: "getAeoPrompts" as const,
  input: z.object({
    status: z.enum(["active", "archived"]).default("active"),
    category: z.string().optional(),
    search: z.string().optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    sortKey: z.enum(["prompt", "category", "createdAt"]).optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
  }),
  output: z.object({
    prompts: z.array(AeoPromptSchema),
    totalCount: z.number(),
    categories: z.array(z.string()),
  }),
};
